// eslint-disable-next-line no-undef
const apiKey = VITE_POSTHOG_API_KEY
// eslint-disable-next-line no-undef
const host = VITE_POSTHOG_API_URL

export default async function usePosthog(enabled) {
  if (enabled && apiKey && host) {
    const posthog = await import('posthog-js')
    posthog.default.init(apiKey, { api_host: host })
  }
}
